import { render } from "./OffCanvasMenu.vue?vue&type=template&id=b83ffd8c&scoped=true"
import script from "./OffCanvasMenu.vue?vue&type=script&lang=js"
export * from "./OffCanvasMenu.vue?vue&type=script&lang=js"

import "./OffCanvasMenu.vue?vue&type=style&index=0&id=b83ffd8c&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\MetaLuxe\\projects\\springst-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b83ffd8c"]])

export default __exports__